import { render, staticRenderFns } from "./LabelContractsEdit.vue?vue&type=template&id=1a7ffed8"
import script from "./LabelContractsEdit.vue?vue&type=script&lang=js"
export * from "./LabelContractsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports